import Vue from 'vue'
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';

const contractInfo = require('./dmexAggregatorContract.json')

let web3 = $web3js.getWeb3();

let contractAddress = $bizConfig.dmexAggregatorContractAddress;
let contractConst = {
  contract: web3 ? new web3.eth.Contract(contractInfo.abi, contractAddress) : '',
}

const getDmexAggregatorAddress = () => {
  return contractAddress;
}

const getDmexAggregatorContract = () => {
  return contractConst.contract;
}
 

export default {
  getDmexAggregatorAddress,
  getDmexAggregatorContract,
}


// WEBPACK FOOTER //
// ./src/lib/contract/dmexAggregator/index.js